import { getNewErrorMessage } from "services/utilsv2";
import FetchService from "../FetchService/CustomService";

const BaseUrl = process.env.BASE_URL;

const InvoiceService = {
  async emailInvoice(data = {}) {
    const url = BaseUrl + `/recruiter/transactions/send-invoice`;

    try {
      const res = await FetchService.postCall({
        url,
        body: data
      });
      return res;
    } catch (error) {
      console.log("Error Getting Email Invoice", error);
      return Promise.reject(getNewErrorMessage(error));
    }
  }
};

export default InvoiceService;
